import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "数字越小越靠前", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.cardVersion,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "所属语系",
          prop: "card_language_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.cardVersion.card_language_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardVersion.card_language_id) = $event)),
              placeholder: "请选择语系",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languageOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "版本名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.cardVersion.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardVersion.name) = $event)),
              placeholder: "请输入版本名称",
              maxlength: "20",
              "show-word-limit": "",
              style: {"width":"300px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sort"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.cardVersion.sort,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardVersion.sort) = $event)),
              min: 0,
              max: 9999
            }, null, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}